import { PencilIcon } from "lucide-react";

import { Icon } from "@/components/atoms/Icon";
import { Button } from "@/components/ui/button";
import { cn } from "@/components/ui/utils";
import { useListContext } from "./List.hooks";

export function ListEditOptionsButton() {
  const { onNewRow, isLoading, classes } = useListContext();

  if (!onNewRow || isLoading) return null;

  return (
    <div
      className={cn(
        "min-w-0 box-border w-full p-1 flex items-center justify-start bg-popover gap-1",
        classes.listItem,
        "[border-top-width:1px] [border-top-style:solid] border-border",
      )}
    >
      <Button
        variant="ghost"
        size="sm"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => onNewRow("")}
        className="[box-shadow:none]"
      >
        <Icon ReactIcon={PencilIcon} />
        Edit options
      </Button>
    </div>
  );
}
